/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * PaginationInfoBase
 * auto generated base class for the model PaginationInfoModel.
 */
export const PaginationInfoModelBase = ModelBase.named('PaginationInfo')
  .props({
    __typename: types.optional(types.literal('PaginationInfo'), 'PaginationInfo'),
    currentPage: types.union(types.undefined, types.number),
    pageSize: types.union(types.undefined, types.number),
    totalGames: types.union(types.undefined, types.number),
    totalPages: types.union(types.undefined, types.number)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PaginationInfoModelSelector extends QueryBuilder {
  get currentPage() {
    return this.__attr('currentPage')
  }
  get pageSize() {
    return this.__attr('pageSize')
  }
  get totalGames() {
    return this.__attr('totalGames')
  }
  get totalPages() {
    return this.__attr('totalPages')
  }
}
export function selectFromPaginationInfo() {
  return new PaginationInfoModelSelector()
}

export const paginationInfoModelPrimitives = selectFromPaginationInfo().currentPage.pageSize.totalGames.totalPages
